import { z } from 'zod';

export type EntityWithTitle = {
	id: number;
	title: string;
};

export const entityWithTitleSchema: z.ZodType<EntityWithTitle> = z.object({
	id: z.number(),
	title: z.string(),
});
